<template>
  <div class="deck-loading">
    <div class="deck-loading-item">
      <slot />
    </div>
  </div>
</template>

<style lang="stylus">
.deck-loading-item
  @apply flex items-center justify-center absolute w-full h-full text-white

.deck-loading
  @apply relative h-screen w-screen bg-gray-800 overflow-hidden lg_text-base text-sm
  background radial-gradient(#4a4a4a, #212121)
</style>
